import { memo, useCallback, useMemo } from 'react';
import classNames from 'classnames';

import { ImageEmbedded } from '../../image/image-embedded';
import { Link } from '../../link/link';
import { trackHeaderNavigation } from '../../../utils/analytics/use-navigation-menu-tracking';

import { NavItemIsEmptyFn, NavItemProps } from './nav-item.config';
import { NavItemContent } from './nav-item-content/nav-item-content';

const NavItem = memo(
  ({
    additionalClasses,
    flag,
    icon,
    button,
    linkDescription,
    propertiesId,
    propertiesLabel,
    propertiesRole,
    ...props
  }: NavItemProps) => {
    const renderedIcon = useMemo(
      () => icon && <ImageEmbedded {...icon} baseCssClass="snowflake-mega-nav-nav-item-icon" />,
      [icon]
    );

    const onLinkClick = useCallback(() => {
      trackHeaderNavigation(button);
    }, [button]);

    return !NavItemIsEmptyFn({ button, ...props }) ? (
      <div
        className={classNames('snowflake-mega-nav-nav-item', additionalClasses)}
        data-testid="snowflake-mega-nav-nav-item"
        id={propertiesId}
        aria-label={propertiesLabel}
        role={propertiesRole}
      >
        <Link dataTestid="snowflake-mega-nav-nav-item-link" onClick={onLinkClick} link={button?.buttonLink}>
          {renderedIcon}
          <NavItemContent button={button} flag={flag} linkDescription={linkDescription} />
        </Link>
      </div>
    ) : null;
  }
);

NavItem.displayName = 'NavItem';

export default NavItem;
